module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Update Company")])], 1), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "id": "company-settings"
    }
  }, [(_vm.companySettingsLoading) ? _c('v-container', {
    staticStyle: {
      "min-height": "130px"
    },
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "py-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "color": "primary"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.companySettingsLoading) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCompanySettings.apply(null, arguments)
      }
    }
  }, [_c('input', {
    ref: "companylogo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".jpeg, .png, .jpg"
    },
    on: {
      "change": _vm.setTempCompanyLogo
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "grid-list-md",
    staticStyle: {
      "max-width": "none",
      "padding": "20px 41px 0px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-layout', {
    staticClass: "pl-3 pt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('template', {
    slot: "activator"
  }, [_c('div', {
    staticClass: "profile-pic round"
  }, [(!_vm.companySettingsForm.companylogo) ? _c('img', {
    attrs: {
      "src": _vm.tempCompanyLogo || '/static/images/yourlogo.png',
      "alt": _vm.companySettingsForm.companylegalname
    }
  }) : _vm._e(), _vm._v(" "), (_vm.companySettingsForm.companylogo) ? _c('img', {
    attrs: {
      "src": _vm.tempCompanyLogo || _vm.companySettingsForm.companylogo,
      "alt": _vm.companySettingsForm.companylegalname
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "profile-upload-overlay",
    class: {
      disabled: _vm.readonly
    },
    attrs: {
      "justify-center": "",
      "row": "",
      "align-center": ""
    },
    on: {
      "click": function($event) {
        return _vm.pickFile('companylogo')
      }
    }
  }, [_c('div', [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("mdi-camera")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Upload image")])], 1)])], 1)]), _vm._v(" "), (!_vm.readonly) ? _c('span', [_vm._v("200px * 200px Recommended size")]) : _c('span', [_vm._v("View only")])], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md9": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Company Name",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.companylegalname),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companylegalname", $$v)
      },
      expression: "companySettingsForm.companylegalname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address Line 1",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.addressline1),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "addressline1", $$v)
      },
      expression: "companySettingsForm.addressline1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address Line 2",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.addressline2),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "addressline2", $$v)
      },
      expression: "companySettingsForm.addressline2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.city),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "city", $$v)
      },
      expression: "companySettingsForm.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Latitude",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.latitude),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "latitude", $$v)
      },
      expression: "companySettingsForm.latitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Longitude",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.longitude),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "longitude", $$v)
      },
      expression: "companySettingsForm.longitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "County",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.county),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "county", $$v)
      },
      expression: "companySettingsForm.county"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Zip",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.zip),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "zip", $$v)
      },
      expression: "companySettingsForm.zip"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    staticClass: "pr-2 mt-0",
    attrs: {
      "items": [
        'AK',
        'AL',
        'AR',
        'AZ',
        'CA',
        'CO',
        'CT',
        'DE',
        'FL',
        'GA',
        'HI',
        'IA',
        'ID',
        'IL',
        'IN',
        'KS',
        'KY',
        'LA',
        'MA',
        'MD',
        'ME',
        'MI',
        'MN',
        'MO',
        'MS',
        'MT',
        'NC',
        'ND',
        'NE',
        'NH',
        'NJ',
        'NM',
        'NV',
        'NY',
        'OH',
        'OK',
        'OR',
        'PA',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VA',
        'VT',
        'WA',
        'WI',
        'WV',
        'WY' ],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "State:"
    },
    model: {
      value: (_vm.companySettingsForm.state),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "state", $$v)
      },
      expression: "companySettingsForm.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Company Website",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.businesswebsite),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "businesswebsite", $$v)
      },
      expression: "companySettingsForm.businesswebsite"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Public Contact Phone Number",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.phonenumber),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "phonenumber", $$v)
      },
      expression: "companySettingsForm.phonenumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Public Contact Email",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.email),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "email", $$v)
      },
      expression: "companySettingsForm.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(
    _vm.companySettingsForm.companyprimaryindustry !== 'Other'
  ) ? _c('v-select', {
    attrs: {
      "items": _vm.primaryIndustry,
      "label": "Primary Industry",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.companyprimaryindustry),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companyprimaryindustry", $$v)
      },
      expression: "companySettingsForm.companyprimaryindustry"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.companySettingsForm.companyprimaryindustry === 'Other'
  ) ? _c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Enter Primary Industry",
      "no-data-text": "Type to add data",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "placeholder": "Primary Industry"
    },
    model: {
      value: (_vm.companySettingsForm.companyprimaryindustry),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companyprimaryindustry", $$v)
      },
      expression: "companySettingsForm.companyprimaryindustry"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "grid-list-md",
    staticStyle: {
      "max-width": "none",
      "padding": "0px 41px",
      "padding-bottom": "20px"
    }
  }, [_c('v-layout', {
    staticClass: "pt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": "Company Description",
      "maxlength": "250",
      "counter": 250,
      "rules": [function (val) { return val.length <= 250 || 'Max 250 characters'; }],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.companydescription),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companydescription", $$v)
      },
      expression: "companySettingsForm.companydescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DUNS Number",
      "rules": [
        function () { return _vm.companySettingsForm.dunsnumber.length > 9 ?
        'You can only add 9 characters' :
        true; },
        function () { return _vm.companySettingsForm.dunsnumber.length < 9 ?
        'Must be of 9 digits' :
        true; } ],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.dunsnumber),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "dunsnumber", $$v)
      },
      expression: "companySettingsForm.dunsnumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cage Code",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.cagecode),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "cagecode", $$v)
      },
      expression: "companySettingsForm.cagecode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Yes', 'No'],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Federal Contractor?"
    },
    model: {
      value: (_vm.companySettingsForm.fedcontractor),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "fedcontractor", $$v)
      },
      expression: "companySettingsForm.fedcontractor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Federal Contractor Type",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.fedcontractortype),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "fedcontractortype", $$v)
      },
      expression: "companySettingsForm.fedcontractortype"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.naicscodes,
      "label": "Primary NAICS Code",
      "no-data-text": "Type to add data",
      "cache-items": "",
      "search-input": _vm.naicsSearch,
      "autocomplete": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    on: {
      "update:searchInput": function($event) {
        _vm.naicsSearch = $event
      },
      "update:search-input": function($event) {
        _vm.naicsSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.primarynaicscode),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "primarynaicscode", $$v)
      },
      expression: "companySettingsForm.primarynaicscode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.additionalNaicscodes,
      "no-data-text": "Type to add data",
      "search-input": _vm.additionalNaicsSearch,
      "autocomplete": "",
      "rules": [
        function () { return _vm.companySettingsForm.additionalnaicscodes.length > 5 ?
        'You can only add five codes' :
        true; } ],
      "multiple": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Additional NAICS Codes"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.additionalNaicsSearch = $event
      },
      "update:search-input": function($event) {
        _vm.additionalNaicsSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.additionalnaicscodes),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "additionalnaicscodes", $$v)
      },
      expression: "companySettingsForm.additionalnaicscodes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.psccodes,
      "label": "Primary PSC Code",
      "cache-items": "",
      "no-data-text": "Type to add data",
      "search-input": _vm.pscSearch,
      "autocomplete": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    on: {
      "update:searchInput": function($event) {
        _vm.pscSearch = $event
      },
      "update:search-input": function($event) {
        _vm.pscSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.primarypsccode),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "primarypsccode", $$v)
      },
      expression: "companySettingsForm.primarypsccode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.additionalPsccodes,
      "no-data-text": "Type to add data",
      "search-input": _vm.additionalPscSearch,
      "autocomplete": "",
      "cache-items": "",
      "multiple": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Additional PSC Codes"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.additionalPscSearch = $event
      },
      "update:search-input": function($event) {
        _vm.additionalPscSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.additionalpsccodes),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "additionalpsccodes", $$v)
      },
      expression: "companySettingsForm.additionalpsccodes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "items": _vm.certifications,
      "multiple": "",
      "cache-items": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Company Certifications"
    },
    model: {
      value: (_vm.companySettingsForm.companycertifications),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companycertifications", $$v)
      },
      expression: "companySettingsForm.companycertifications"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'None',
        'TOP SECRET',
        'SECRET',
        'CONFIDENTIAL',
        'FACILITY',
        'Q Clearance',
        'L Clearance' ],
      "label": "Security Clearance",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.securityclearance),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "securityclearance", $$v)
      },
      expression: "companySettingsForm.securityclearance"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": "Specialties",
      "maxlength": "250",
      "height": 80,
      "counter": 250,
      "rules": [function (val) { return val.length <= 250 || 'Max 250 characters'; }],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.specialties),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "specialties", $$v)
      },
      expression: "companySettingsForm.specialties"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": "Capabilities",
      "maxlength": "250",
      "height": 80,
      "counter": 250,
      "rules": [function (val) { return val.length <= 250 || 'Max 250 characters'; }],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.capabilities),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "capabilities", $$v)
      },
      expression: "companySettingsForm.capabilities"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-align-left": ""
    }
  }, [_c('input', {
    ref: "companystatement",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accept": ".docx,.doc,.pdf",
      "type": "file"
    },
    on: {
      "change": _vm.setTempCompanyStatement
    }
  }), _vm._v(" "), (_vm.companySettingsForm.capabilitiesstatement.length) ? _c('v-btn', {
    staticStyle: {
      "margin": "0px 10px 0px 0px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "href": _vm.companySettingsForm.capabilitiesstatement,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": "/static/img/my-cap-stat.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin": "0px 10px 0px 0px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "disabled": _vm.readonly,
      "label": "Upload",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pickFile('companystatement')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": "/static/img/upload-icon.png"
    }
  })]), _vm._v("\n              " + _vm._s(_vm.statementFileName) + "\n            ")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-4": ""
    }
  }, [_c('v-layout', [_c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "type": "submit",
      "dark": "",
      "disabled": _vm.readonly,
      "loading": _vm.loading
    }
  }, [_vm._v("\n                  Update\n                  "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa7dc29c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Components/CompanyModal.vue
// module id = 1735
// module chunks = 7